import { usePromotion } from "../hooks/usePromotion";
import BuyButton from "./BuyButton";

export default function MobileBar() {
  const { active } = usePromotion();
  return (
    <div
      data-testid="sticky-mobile-bar"
      className="fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-[#242344]/95 px-4 py-3 backdrop-blur-md md:hidden"
    >
      <div className="flex items-center justify-between gap-3">
        {active ? (
          <div className="leading-tight">
            <p className="text-sm font-extrabold text-white">
              <del className="mr-1.5 text-base font-extrabold text-white/80">399 zł</del>
              249 zł <span className="font-semibold text-white/80">brutto</span>
            </p>
            <p className="text-xs text-white/70">Cena promocyjna · Do 20.10, do północy</p>
          </div>
        ) : (
          <div className="leading-tight">
            <p className="text-sm font-extrabold text-white">399 zł brutto</p>
            <p className="text-xs text-white/70">Promocja zakończona</p>
          </div>
        )}
        <BuyButton testid="sticky-mobile-cta" location="sticky-mobile" className="!min-h-[44px] !px-5 !py-2 !text-sm" />
      </div>
    </div>
  );
}
